import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getList, remove, update, add, getDict, getDictTree } from "@/api/system/dict";
import { mapGetters } from "vuex";
export default {
  data: function data() {
    return {
      form: {},
      selectionList: [],
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        tree: true,
        border: true,
        index: true,
        selection: true,
        viewBtn: true,
        menuWidth: 300,
        dialogWidth: 880,
        column: [{
          label: "字典编号",
          prop: "code",
          search: true,
          span: 24,
          rules: [{
            required: true,
            message: "请输入字典编号",
            trigger: "blur"
          }]
        }, {
          label: "字典名称",
          prop: "dictValue",
          search: true,
          align: "center",
          rules: [{
            required: true,
            message: "请输入字典名称",
            trigger: "blur"
          }]
        }, {
          label: "上级字典",
          prop: "parentId",
          type: "tree",
          dicData: [],
          hide: true,
          props: {
            label: "title"
          },
          rules: [{
            required: false,
            message: "请选择上级字典",
            trigger: "click"
          }]
        }, {
          label: "字典键值",
          prop: "dictKey",
          type: "number",
          rules: [{
            required: true,
            message: "请输入字典键值",
            trigger: "blur"
          }]
        }, {
          label: "字典排序",
          prop: "sort",
          type: "number",
          rules: [{
            required: true,
            message: "请输入字典排序",
            trigger: "blur"
          }]
        }, {
          label: "封存",
          prop: "isSealed",
          type: "select",
          dicData: [{
            label: "否",
            value: 0
          }, {
            label: "是",
            value: 1
          }],
          slot: true,
          rules: [{
            required: true,
            message: "请选择封存",
            trigger: "blur"
          }]
        }, {
          label: "字典备注",
          prop: "remark",
          search: true,
          hide: true
        }]
      },
      data: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["permission"])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: this.vaildData(this.permission.dict_add, false),
        viewBtn: this.vaildData(this.permission.dict_view, false),
        delBtn: this.vaildData(this.permission.dict_delete, false),
        editBtn: this.vaildData(this.permission.dict_edit, false)
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  }),
  mounted: function mounted() {
    var _this = this;

    getDictTree().then(function (res) {
      var column = _this.findObject(_this.optionChild.column, "parentId");

      column.dicData = res.data.data;
    });
  },
  methods: {
    handleAdd: function handleAdd(row) {
      this.$refs.crud.value.code = row.code;
      this.$refs.crud.value.parentId = row.id;
      this.$refs.crud.option.column.filter(function (item) {
        if (item.prop === "code") {
          item.value = row.code;
          item.addDisabled = true;
        }

        if (item.prop === "parentId") {
          item.value = row.id;
          item.addDisabled = true;
        }
      });
      this.$refs.crud.rowAdd();
    },
    rowSave: function rowSave(row, done, loading) {
      var _this2 = this;

      add(row).then(function () {
        _this2.onLoad(_this2.page);

        _this2.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate: function rowUpdate(row, index, done, loading) {
      var _this3 = this;

      update(row).then(function () {
        _this3.onLoad(_this3.page);

        _this3.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowDel: function rowDel(row) {
      var _this4 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(row.id);
      }).then(function () {
        _this4.onLoad(_this4.page);

        _this4.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    searchReset: function searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete: function handleDelete() {
      var _this5 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this5.ids);
      }).then(function () {
        _this5.onLoad(_this5.page);

        _this5.$message({
          type: "success",
          message: "操作成功!"
        });

        _this5.$refs.crud.toggleSelection();
      });
    },
    beforeOpen: function beforeOpen(done, type) {
      var _this6 = this;

      if (["edit", "view"].includes(type)) {
        getDict(this.form.id).then(function (res) {
          _this6.form = res.data.data;
        });
      }

      done();
    },
    beforeClose: function beforeClose(done) {
      this.$refs.crud.tableForm = {};
      this.$refs.crud.value.code = "";
      this.$refs.crud.value.parentId = "";
      this.$refs.crud.value.addDisabled = false;
      this.$refs.crud.option.column.filter(function (item) {
        if (item.prop === "code") {
          item.value = "";
          item.addDisabled = false;
        }

        if (item.prop === "parentId") {
          item.value = "";
          item.addDisabled = false;
        }
      });
      done();
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this7 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(function (res) {
        _this7.data = res.data.data;
        _this7.loading = false;

        _this7.selectionClear();
      });
    }
  }
};